export const TEXTS = {
  ge: {
    home: "მთავარი",
    about: "ვინ ვართ ჩვენ",
    services: "პროგრამები",
    portfolio: "ვორქშოფები",
    contact: "საკონტაქტო",
    whoAreWe:
      " ვინ ვართ ჩვენ? - მარკეტერები, რომლებიც საქმის სუპერ პროფესიონალები ვართ.",
    ourVisionIs: "ჩვენი ხედვა ესეთია:",
    provideCustomers:
      " მიაწოდე მომხმარებელს სიახლე, კრეატივი, ხარისხი და ემოცია. ",
    whatIsYours: "რა არის შენი ",
    life: "ცხოვრების",
    main: "მთავარი",
    blueprint: "ეზობანა?",
    onlyEnglish: "",
    findOut: "აღმოაჩინე ",
    more: "გაიგე მეტი",
    studio: "დაბადების დღის",
    order: "შეგვიკვეთე ახლავე",
    gift: "სასაჩუქრე იდეები",
    production: "ფროდაქშენი",
    socNet: "სოციალური ქსელების მართვა",
    polygraph: "პოლიგრაფია",
    address: "მისამართი",
    phone: "ტელეფონი",
    email: "ელ-ფოსტა",
    workingHours: "სამუშაო საათები",
    monday: "ორშაბათი - კვირა",
    saturday: "შაბათი",
    sunday: "კვირა",
    restDay: "დასვენების დღე",
    getInTouch: "დაგვიკავშირდით",
    name: "სახელი",
    message: "შეტყობინება",
    send: "გაგზავნა",
    madeBy: "© 2025 დამზადებულია Bestsoft-ის მიერ",
  },

  en: {
    home: "HOME",
    about: "WHO ARE WE ",
    services: "PROGRAMS",
    portfolio: "WORKSHOPS",
    contact: "CONTACT",
    whoAreWe: "who are we? - Marketers who are super professionals.",
    ourVisionIs: "Our vision is:",
    provideCustomers:
      "Provide customers with news, creative, quality and emotion.",
    whatIsYours: "what is the",
    life: "main",
    blueprint: "ezobana",
    onlyEnglish: "in your life",
    youPlanYourVision:
      "You plan your vision, you plan your purpose that's we call your life blueprint",
    findOut: "Find out",
    more: "READ MORE",
    studio: "BIRTHDAY",
    order: "order now",
    gift: "GIFT IDEAS",
    production: "PRODUCTION",
    socNet: "MANAGEMENT OF SOCIAL NETWORKS",
    polygraph: "POLYGRAPH",
    address: "Address",
    phone: "Phone",
    email: "Email",
    workingHours: "Working Hours",
    monday: "Monday - Sunday",
    saturday: "Saturday",
    sunday: "Sunday",
    restDay: "Day Off",
    getInTouch: "Get In Touch",
    name: "Name",
    message: "Message",
    send: "Send",
    madeBy: "© 2025 Made by Bestsoft",
  },
};
